// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"eP","secondary":"eQ","warning":"eR"};